module.exports = __webpack_public_path__ + "static/media/wgv.82f17e68.svg";